import React from 'react';
import './slider-ductsound.css';
import Banner1 from '../../images/ductsound/ductbn2.webp';
import Banner2 from '../../images/ductsound/ductbn3.webp';
import Banner3 from '../../images/ductsound/ductbn4.webp';
import Banner4 from '../../images/ductsound/ductbn5.webp';
function slider() {
	return (
	  
	<>
	<div id="slider-ductsound">
		<div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
  			<ol className="carousel-indicators">
    			<li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
    			<li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
    			<li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
    			<li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
  			</ol>
  			<div className="carousel-inner">
    			<div className="carousel-item active">
      				<img className="d-block w-100" src={Banner1} alt="Ductsound1" />
	  			</div>
    			<div className="carousel-item">
      				<img className="d-block w-100" src={Banner2} alt="Ductsound2" />
	  			</div>
				<div className="carousel-item">
      				<img className="d-block w-100" src={Banner3} alt="Ductsound3" />
	  			</div>
				<div className="carousel-item">
      				<img className="d-block w-100" src={Banner4} alt="Ductsound4" />
	  			</div>
			</div>
  			<a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
    			<span className="carousel-control-prev-icon" aria-hidden="true"></span>
    			<span className="sr-only">Previous</span>
  			</a>
  			<a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
    			<span className="carousel-control-next-icon" aria-hidden="true"></span>
    			<span className="sr-only">Next</span>
  			</a>
		</div>
	</div>
	</>
);
}
export default slider;